import account from './account';
import accountSetting from './passport/accountSetting';
import findPassword from './passport/findPassword';
import repairedAccount from './repairedAccount';
import dialog from './dialog';
import languages from './languages';
import passport from './passport';
import store from './store';
import cash from './cash';
import support from './support';
import services from './services';
import logoConfig from './logoConfig';
import ipCheck from './ipCheck';
import onestoreSubscribe from './passport/onestoreSubscribe';
import tokenLogin from './passport/tokenLogin';
import dma from './dma/index';
import { SWITCH_LANG } from './support/event-type';
// 从链接获取language 语言，并且对文案进行初始化。
languages.init();
export default {
  strict: process.env.NODE_ENV !== 'production', // 在非生产环境下，使用严格模式
  state: {
    cancel: languages.get('cancel'),
    confirm: languages.get('confirm'),
    isRtlDirection: languages.isRtlDirection()
  },
  getters: {
    isRtlDirection: state => {
      return state.isRtlDirection;
    }
  },
  mutations: {
    [SWITCH_LANG](state, lang) {
      languages.setLanguage(lang);
      state.isRtlDirection = languages.isRtlDirection();
    }
  },
  modules: {
    account,
    dialog,
    passport,
    store,
    support,
    cash,
    accountSetting,
    findPassword,
    services,
    repairedAccount,
    logoConfig,
    onestoreSubscribe,
    tokenLogin,
    ipCheck,
    dma
  }
};
